import { ResultOf } from "@graphql-typed-document-node/core";
import { useMemo } from "react";
import { CombinedError, useQuery } from "urql";

import { getFragmentData, graphql } from "@/gen";

const useTrial_Trial = graphql(`
    fragment useTrial_Trial on Trial {
        id
        finishedAt
        round {
            __typename
            id
            scheduledStartAt
        }
        player1 {
            id
            name
            nickname
            imageId
            fideId
        }
        player2 {
            id
            name
            nickname
            imageId
            fideId
        }
        games {
            __typename
            id
            ...GameTable2_Game
        }
        createdAt
        result
    }
`);

export type TrialT = ResultOf<typeof useTrial_Trial>;

export const GameTable2_Game = graphql(`
    fragment GameTable2_Game on Game {
        id
        positionInTrial
        startedAt
        scheduledStartAt
        result
        whitePlayer {
            id
            name
            nickname
        }
        blackPlayer {
            id
            name
            nickname
        }
        pgnRoundTag
    }
`);

export type GameT = ResultOf<typeof GameTable2_Game>;

export const useTrial: (trialId?: string) => {
    trial: TrialT | null | undefined;
    loading: boolean;
    error: CombinedError | undefined;
    refetch: () => void;
} = (trialId?: string) => {
    const [result, refetch] = useQuery({
        query: graphql(`
            query trialQuery($id: UUID!) {
                trial(id: $id) {
                    id
                    ...useTrial_Trial
                }
            }
        `),
        variables: {
            id: trialId!,
        },
        pause: !trialId,
    });

    const trial = useMemo(() => getFragmentData(useTrial_Trial, result.data?.trial), [result.data]);

    return {
        trial,
        loading: result.fetching,
        error: result.error,
        refetch,
    };
};
